import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class BlogAuthor extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get id() {
    return get(this, 'system.id', '');
  }

  get codename() {
    return get(this, 'system.codename', '');
  }

  get name() {
    return get(this, '_name.value', '');
  }

  get position() {
    return get(this, '_position.value', '');
  }

  get description() {
    return get(this, '_description.value', '');
  }

  get image() {
    return get(this, '_image.value[0].url', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/BlogAuthor.model.js